import { combineReducers} from "redux";
import storage from 'redux-persist/lib/storage'
import { FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import { configureStore } from "@reduxjs/toolkit";
import storeReducer from "./Reducer/storeReducer";
import persistStore from "redux-persist/es/persistStore";


const reducers = combineReducers({
    items: storeReducer,
});

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware: any) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})
export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>